<template>
  <div id="transaction">
    <div class="content">
      <!-- NFT模块 -->
      <div class="nft-view">
        <!-- 一级销售 -->
        <div class="primaryMarket">
          <div class="leftView">
            <p class="title">{{ $t("homePage.item") }}</p>
            <div>
              <el-popover
                placement="top"
                :trigger="triggerType"
                :content="nftInfo.name"
              >
                <div slot="reference" class="name">{{ nftInfo.name }}</div>
              </el-popover>
            </div>
            <p class="no">
              <span v-if="nftInfo.type === 'MARKET'">{{
                nftInfo.uniqueId
              }}</span>
            </p>
            <p class="title numTitle" v-if="nftInfo.type === 'MINT'">
              {{ $t("homePage.quantity") }}
            </p>
            <p class="num" v-if="nftInfo.type === 'MINT'">
              <span>x</span>
              <span class="num-text">{{ nftInfo.quantity }}</span>
            </p>
          </div>
          <div class="nftIcon">
            <img :src="nftInfo.picture" alt="" />
          </div>
        </div>
        <!-- 二级销售 -->
        <div class="secondaryMarket">
          <div class="leftView">
            <p class="title">{{ $t("homePage.youPay") }}</p>
            <p class="num">{{ homeCommodityPrice }}</p>
          </div>
          <div class="rightView" @click="openSearch('fiatCurrency')">
            <p class="currency-icon"><img :src="fiatCurrency.icon" alt="" /></p>
            <p class="currency-text">{{ fiatCurrency.code }}</p>
            <p class="right-icon">
              <img
                src="@/assets/images/direction-icon/currency-rightIcon.png"
                alt=""
              />
            </p>
          </div>
        </div>
      </div>
      <p
        style="text-align: right"
        class="exchangeRate"
        v-if="merchantBuyType !== 'CRYPTO'"
      >
        <!--  <template>
            1 {{ fiatCurrency.code }} ≈ {{ toUSD }} {{ nftInfo.fiat }}
        </template> -->
        <!--   <template>
          &asymp;
          {{ Number(Number(homeCommodityPrice) * Number(toUSD)).toFixed(2) }}
          {{ nftInfo.fiat }}
        </template> -->
        <template> &asymp; {{ usdAmount }} USD </template>
      </p>

      <AddressInfo :network="allData.network" :address="allData.address" />

      <!-- {{ nftInfo.targetFiat }} -->
      <!-- 部分商户展示费用信息 -->
      <IncludedDetails
        ref="IncludedDetails_ref"
        :isHome="true"
        v-if="merchantBuyType === 'CRYPTO'"
      />
    </div>

    <div class="confirm-option">
      <button class="confirm" :disabled="disabled" @click="next">
        <p>
          {{ $t("homePage.proceedBuy") }} NFT
          <span style="margin-left: 0.06rem">{{ orderCountDown }}</span>
        </p>
        <p class="rightIcon">
          <img
            src="@/assets/images/direction-icon/button-right-icon.svg"
            alt=""
          />
        </p>
      </button>
      <p class="cookieTips">By continuing you agree to our cookie policy.</p>
      <div class="footer_logoView">
        <p class="logoText">Powered By</p>
        <div class="logo">
          <img src="../../../assets/images/achLogo/homePageLogo.png" alt="" />
          <img src="../../../assets/images/achLogo/homePageLogo1.png" alt="" />
        </div>
      </div>
      <p class="cookieTips">
        Alchemy GPS Europe UAB with address at J. Basanavičiaus g. 26, LT-03224,
        Vilnius, Lithuania
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { hashQuery } from "@/utils/publicRequest";
import common from "@/utils/common";
import IncludedDetails from "@/components/IncludedDetails/IncludedDetails";
import AddressInfo from "@/components/AddressInfo/Index";
import { Toast } from "vant";

export default {
  components: { IncludedDetails, AddressInfo },
  data() {
    return {
      allData: {},
      triggerType: "hover",
    };
  },
  computed: {
    ...mapState("buyNftHome", {
      fiatCurrency: (state) => state.fiatCurrency,
      usdToEXR: (state) => state.usdToEXR,
      EXR: (state) => state.EXR,
      nftInfo: (state) => state.nftInfo,
      commodityPrice: (state) => state.commodityPrice,
      orderCountDown: (state) => state.orderCountDown,
      usdAmount: (state) => state.usdAmount,
    }),

    ...mapState("merchantInfo", {
      merchantBuyType: (state) => state.merchantBuyType,
    }),

    //1法币 === 多少US
    toUSD() {
      // let num = this.$numberHandle(this.$mathJs(1 / this.usdToEXR).done());
      let num = this.$numberHandle(this.usdToEXR);
      return num > 0 && num !== Infinity ? num : 0;
    },
    //计算需要付款法币金额
    homeCommodityPrice() {
      if (this.merchantBuyType === "CRYPTO" && this.commodityPrice) {
        return this.commodityPrice > 0 ? this.commodityPrice : 0;
      }
      // let num,nftAmount;
      // num = this.$numberHandle(this.$mathJs(this.nftInfo.amount / this.usdToEXR).done(),this.fiatCurrency.decimalDigits);
      // nftAmount = this.$numberHandle(this.$mathJs(this.nftInfo.nftAmount / this.usdToEXR).done(),this.fiatCurrency.decimalDigits);
      // nftAmount > 0 ? this.$store.commit("buyNftHome/set_commodityPrice",nftAmount) : this.$store.commit("buyNftHome/set_commodityPrice",0);
      // return num > 0 ? num : 0;
      return this.nftInfo.amount;
    },
    //下一步按钮状态
    disabled() {
      return this.homeCommodityPrice > 0 ? false : true;
    },
  },
  activated() {
    //判断是pc还是移动端，用于展示的提示信息是click还是hover触发
    this.triggerType = common.equipmentEnd === "pc" ? "hover" : "click";
  },
  methods: {
    processingData(data) {
      //商户校验不通过清空原有商户信息
      let merchantInfo =
        JSON.parse(window.sessionStorage.getItem("merchantInfo")) || {};
      if (
        data === null ||
        data === undefined ||
        JSON.stringify(data) === "{}" ||
        data.fiatCurrencyList.length === 0
      ) {
        let nftInfo = {
          amount: "", //NFT法币总金额(包含最高费用)
          nftAmount: "", //NFT法币总金额
          type: "", //类型 MARKET(二级销售)/MINT(一级销售)
          name: "", //名称
          picture: "", //图片地址
          quantity: "", //数量
          uniqueId: "", //NFT id
          redirectUrl: "", //支付成功后的跳转URL
          appId: "", //商户应用的唯一标识
          merchantName: "", //商户名称
          targetFiat: "",
          fiat: "",
        };
        this.assignmentData(nftInfo, {}, "", "");
        this.$store.commit("buyNftHome/set_orderTime", "");
        this.$store.dispatch("buyNftHome/change_orderTimeOut");
        window.sessionStorage.removeItem("merchantInfo");
        return;
      }
      //获取商户信息
      this.queryMerchantInfo();
      //存储商户信息
      this.allData = data;
      let routerQuery = JSON.parse(JSON.stringify(hashQuery().query));

      let nftInfoAmount = "";
      if (routerQuery.fiat === routerQuery.targetFiat) {
        nftInfoAmount = routerQuery.amount;
      }

      let nftInfo = {
        amount: nftInfoAmount,
        nftAmount: routerQuery.nftAmount
          ? routerQuery.nftAmount
          : merchantInfo.nftAmount, //NFT法币总金额
        type: routerQuery.type ? routerQuery.type : merchantInfo.type, //类型 MARKET/MINT
        name: routerQuery.name ? routerQuery.name : merchantInfo.name, //名称
        picture: routerQuery.picture
          ? routerQuery.picture
          : merchantInfo.picture, //图片地址
        quantity: routerQuery.quantity
          ? routerQuery.quantity
          : merchantInfo.quantity, //数量
        uniqueId: routerQuery.uniqueId
          ? routerQuery.uniqueId
          : merchantInfo.uniqueId, //NFT id
        redirectUrl: routerQuery.redirectUrl
          ? routerQuery.redirectUrl
          : merchantInfo.redirectUrl, //支付成功后的跳转URL
        appId: routerQuery.appId ? routerQuery.appId : merchantInfo.appId, //商户应用的唯一标识
        merchantName: routerQuery.merchantName
          ? routerQuery.merchantName
          : merchantInfo.merchantName, //商户名称
        targetFiat: routerQuery.targetFiat
          ? routerQuery.targetFiat
          : merchantInfo.targetFiat
          ? merchantInfo.targetFiat
          : "",
        fiat: routerQuery.fiat
          ? routerQuery.fiat
          : merchantInfo.fiat
          ? merchantInfo.fiat
          : "",
        cryptoAmount: routerQuery.cryptoAmount
          ? routerQuery.cryptoAmount
          : merchantInfo.cryptoAmount
          ? merchantInfo.cryptoAmount
          : "",
        crypto: routerQuery.crypto
          ? routerQuery.crypto
          : merchantInfo.crypto
          ? merchantInfo.crypto
          : "",
      };
      //过滤汇率
      // let exr = data.fiatCurrencyList[0].exr[this.nftInfo.targetFiat] || 1;
      //计算汇率
      // let calculationEXR = data.fiatCurrencyList[0].exr[this.fiatCurrency.fiat] || 1;
      let exr = data.fiatCurrencyList[0].exr[nftInfo.fiat] || 1;
      this.assignmentData(
        nftInfo,
        data.fiatCurrencyList[0],
        exr,
        data.nftParamNo,
      ); //data.usdToEXR[data.fiatCurrencyList[0].code]
      this.$store.commit(
        "buyNftHome/set_orderTime",
        routerQuery.timeout ? routerQuery.timeout : merchantInfo.timeout,
      );
      this.$store.dispatch("buyNftHome/change_orderTimeOut");

      let routeQuery = JSON.parse(JSON.stringify(hashQuery()));
      if (!routeQuery.query.cryptoAmount) {
        this.queryNftAmount();
      }
      //币本位商户
      routeQuery.query.cryptoAmount
        ? this.$store.commit("merchantInfo/set_merchantBuyType", "CRYPTO")
        : this.$store.commit("merchantInfo/set_merchantBuyType", "");
      //币本位商户获取费用信息
      if (this.merchantBuyType === "CRYPTO") {
        this.$nextTick(() => {
          this.$refs.IncludedDetails_ref.scenarioVerification();
        });
      }
    },

    //赋值页面基本数据
    assignmentData(nftInfo, fiatCurrency, usdToEXR, nftParamId) {
      //存储商户信息
      this.$store.commit("buyNftHome/set_nftInfo", nftInfo);
      //存储展示法币信息
      this.$store.commit("buyNftHome/set_fiatCurrency", fiatCurrency);
      //存储法币汇率
      this.$store.commit("buyNftHome/set_usdToEXR", usdToEXR);
      //存储nftParamNo
      this.$store.commit("buyNftHome/set_nftParamNo", nftParamId);
    },

    //获取商户信息
    queryMerchantInfo() {
      //带入商户信息
      let merchantInfo = "";
      if (JSON.stringify(hashQuery().query) !== "{}") {
        merchantInfo = "?" + JSON.parse(JSON.stringify(hashQuery())).fullPath;
      } else {
        merchantInfo = JSON.parse(sessionStorage.getItem("merchantInfo"))
          ? "?" +
            JSON.parse(sessionStorage.getItem("merchantInfo")).merchantParam
          : "";
      }
      this.$axios
        .get(this.$api.get_merchantInfo + merchantInfo, "")
        .then((res) => {
          if (res && res.data) {
            this.$store.commit(
              "buyNftHome/set_merchantName",
              res.data.merchantName,
            );
            res.data.redirectUrl !== ""
              ? this.$store.commit(
                  "buyNftHome/set_redirectUrl",
                  res.data.redirectUrl,
                )
              : "";
            //支付跳转第三方链接类型 merchantMethodName存在即为app唤起链接方法
            if (["4"].includes(res.data.merchantJoinMethod)) {
              this.$store.commit(
                "merchantInfo/set_merchant_equipmentEnd",
                "app",
              );
            } else {
              this.$store.commit(
                "merchantInfo/set_merchant_equipmentEnd",
                "web",
              );
            }
          }
        });
    },

    //修改法币信息
    changeFiatCurrency(val) {
      this.$store.commit("buyNftHome/set_fiatCurrency", val);
      let exr = val.exr[this.nftInfo.fiat] || 1;
      this.$store.commit("buyNftHome/set_usdToEXR", exr); //this.allData.usdToEXR[val.code]

      if (this.merchantBuyType === "CRYPTO") {
        //币本位商户调用费用接口
        this.$nextTick(() => {
          this.$refs.IncludedDetails_ref.scenarioVerification();
        });
      } else {
        this.$nextTick(() => {
          this.queryNftAmount();
        });
      }
    },

    //查询NFT价格
    queryNftAmount() {
      let _this = this;
      this.$nextTick(() => {
        let params = {
          fiat: this.fiatCurrency.code,
          crypto: this.nftInfo.crypto || "",
          cryptoAmount: this.nftInfo.cryptoAmount || "",
          name: this.nftInfo.name,
        };
        //带入商户信息
        let merchantInfo = "";
        if (JSON.stringify(hashQuery().query) !== "{}") {
          merchantInfo = "?" + JSON.parse(JSON.stringify(hashQuery())).fullPath;
        } else {
          merchantInfo = JSON.parse(sessionStorage.getItem("merchantInfo"))
            ? "?" +
              JSON.parse(sessionStorage.getItem("merchantInfo")).merchantParam
            : "";
        }
        this.$axios
          .post(this.$api.post_feeInfo + merchantInfo, params, "")
          .then((res) => {
            if (res && res.data) {
              //存储NFT金额
              _this.$store.commit(
                "buyNftHome/set_amount",
                res.data.fiatSumAmount,
              );
              _this.$store.commit(
                "buyNftHome/set_payAmount",
                res.data.fiatSumAmount,
              );
            }
          });
      });
    },

    //打开搜索组件
    openSearch(name) {
      if (JSON.stringify(this.allData) === "{}") {
        return;
      }
      this.$parent.openSearch(name);
    },

    //下一步
    next() {
      //订单超时无法下一步
      if (this.orderCountDown === "00:00:00") {
        this.$toast({
          message: this.$t("homePage.tiemErrToast"),
          duration: 3000,
        });
        return;
      }

      //USD法币禁止下一步
      // if(this.fiatCurrency.code === 'USD' && ['sbx','production','pre'].includes(process.env.VUE_APP_TITLE)){
      //   Toast({
      //     duration: 3000,
      //     message: this.$t('homePage.USDTips')
      //   });
      //   return;
      // }

      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") === "" ||
        localStorage.getItem("token") === null
      ) {
        this.$router.push(`/emailCode`);
        return;
      }

      this.$store.commit("buyNftHome/set_payAmount", this.homeCommodityPrice);
      this.$router.push("/paymentMethod");
    },
  },
};
</script>

<style lang="scss" src="../css/fiatCurrencyBuyNft.scss" scoped></style>
